import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Button } from "antd";

import "./style/import-app.scss";
import { useSelector } from "react-redux";

import { ReactComponent as Import } from "../../../../assets/svg/MarketplaceFunctions/Vector.svg";
import { ImportInstalledApp } from "./ImportInstalledApp";
import { AppCategories } from "./AppCategories";
import { Spinner } from "../../../../helpers/commonUi/Spinner";
import { useToast } from '../../../../helpers/commonFunction';
import { Http } from "../../../../helpers/axois";
import { logger } from "../../../../constant/winston";
import { AppState } from "../../../../stateManager/store";
import { APIURL } from "../../../../constant/common";
import UploadApps from "./UploadApps";

const allCatagories: string[] = ["Apps", "Installed Apps", "Upload Apps"];
interface Iprops {
  setRender?: any;
  render?: boolean;
  callGetApps?: (val: boolean) => void;
}
export const ImportApp: React.FC<Iprops> = ({ setRender, render, callGetApps }) => {
  const [visible, setVisible] = useState<{ visible: boolean, type: string }>({
    visible: false,
    type: "Imports",
  });
  const [activeTab, setActiveTab] = useState<string>('Apps');
  const [appName, setAppName] = useState<string>("");
  const [appIdentifier, setAppIdentifier] = useState<string>("");
  const [appData, setAppData] = useState<any>([]);
  const [selectedApp, setSelectedApp] = useState<any>({});
  const orgId = useSelector((state: AppState) => state.org?.selectedOrg?.id || "");
  const [loading, setLoading] = useState(false)
  const { ErrorToast, SuccessToast } = useToast();
  const [appIdt, setAppIdt] = useState("");
  const [appNa, setAppNa] = useState("");
  const [selectedAppVal, setSelectedAppVal] = useState(null);
  const [loadingButton,setLoadingbutton] = useState(false)
  const [errorMessage,setErrorMessage] = useState(false)
  const [searchValue, setSearchValue] = useState("")

  useEffect(() => {
    if (selectedAppVal === null) {
      setErrorMessage(false)
    }
  }, [selectedAppVal])

  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const { selectedOrg } = useSelector((state: AppState) => state.org)
const loggedInUserId = useSelector((state: any) => {
    return state.user.data.user.id
})
  const getFilteredApps = () => {
    if (activeTab === "Installed Apps") {
      return appData.filter(({ is_installed }: any) => is_installed);

    }
    return appData;
  };

  const onClick = (value: any) => {
    setActiveTab(value);
  };
  const showModal = (): void => {
    setVisible({ visible: true, type: "Imports" });
  };

  const handleOk = (): void => {
    setVisible({ visible: false, type: "Imports" });
  };

  const handleImport = async () => {
    if ((!orgPermissions?.includes("app.Import") || !orgPermissions.includes('org.View')) && loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    }
    Http.get(
      `orgs/${orgId}/marketplaceApps/${selectedApp.id}`
    ).subscribe((res: any) => {

      const { object_url, type } = res.data
      const data = {
        orgId,
        type,
        name: appIdentifier,
        displayName: appName,
        objectUrl: object_url
      };
      if (appIdentifier.length === 0) {
        return ErrorToast("IdentifierName should not be empty")
      }
      if (appName.length === 0) {
        return ErrorToast("DisplayName should not be empty")
      }
      setLoading(true)
      Http.post("/apps/marketplace/import", data).subscribe(
        (_res) => {
          setVisible({ visible: false, type: "Import" });
          if (render) {
            setRender(true)
          } else {
            callGetApps && callGetApps(true)
          }
          SuccessToast("App imported");
          setLoading(false)
        },
        (err) => {
          if (err?.message?.includes("already exists")) {
            ErrorToast("App with this name already exists");
          } else if (err === "Forbidden") {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
        }
          setLoading(false)
        }
      );
    }, (err) => {
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      }
    });
  }

  const getAppData = () => {
    if ((!orgPermissions?.includes("marketplace.PublishApp") || !orgPermissions.includes('org.View'))&& loggedInUserId!=selectedOrg?.owner) {
      return
    }
    if (!appData.length) {
      Http.get(
        `/orgs/${orgId}/marketplaceApps`
      ).subscribe((res: any) => {
        if (res) {
          setAppData(res.data);
        }
      }, (e) => {
        if (e === "Forbidden") {
          console.error("Not Authorized: Please request owner of this organization to provide access")
        }
        logger.error(e);
      });
    }
  }

  useEffect(() => {
    setAppName(selectedApp.name);
    setAppIdentifier(selectedApp.name);
  }, [selectedApp])

  if (!appData) {
    return (
      <Spinner />
    )
  }

  const handleAppDataChange = (newAppId: string, newAppName: string,  selectedAppVal: any) => {
    setAppIdt(newAppId);
    setAppNa(newAppName);
    setSelectedAppVal(selectedAppVal)
  };

  const importFile = async () => {
    if (!appNa && !appIdt) {
      ErrorToast("Please Fill details in the form");
      return;
    }
    if (selectedAppVal === null) {
      ErrorToast("Please upload the file.");
    }
    setLoadingbutton(true);
    const formData = new FormData();
    if (selectedAppVal) {
      formData.append("file", selectedAppVal);
    }
    try {
      setErrorMessage(false)
      const res: any = await Http.post(
        `${APIURL}orgs/${orgId}/marketplaceApps/file/upload`,
        formData
      ).toPromise();
      const data = {
        orgId,
        type: res.type,
        name: appIdt,
        displayName: appNa,
        objectUrl: res.url,
      };

      Http.post("/apps/marketplace/import", data).subscribe(
        () => {
          setVisible({ visible: false, type: "Import" });
          render ? setRender(true) : callGetApps?.(true);
          SuccessToast("App imported");
          setAppIdt("");
          setAppNa("");
          setSelectedAppVal(null)
          setErrorMessage(false)
        },
        (err) => {
          err?.message?.includes("already exists")
            ? ErrorToast("App with this name already exists")
            : err === "Forbidden" &&
            ErrorToast(
              "Not Authorized: Please request owner of this organization to provide access"
            );
          setErrorMessage(true)
        }
      );
      setErrorMessage(false)
    } catch (error) {
      setLoadingbutton(false)
      setErrorMessage(true)
    } finally {
      setLoadingbutton(false)
    }
  };

  return (
    <div onClick={getAppData} className="app-import">
      <Import title="Import App" data-test-id="show_modal" height="25px" width="25px" onClick={showModal} />
      {visible.type === "Imports" ?

        <Modal
          className="override-modal importApps-modal"
          style={{ top: "66px" }}
          width="1115px"
          title="IMPORT APPS"
          visible={visible.visible}
          onOk={handleOk}
          onCancel={() => { setVisible({ visible: false, type: "Imports" }) }
          }
          footer={
            activeTab === "Upload Apps"
              ? [
                <Button key="cancel" className="uploadApp-btn-cancel" onClick={() => setVisible({ visible: false, type: "Imports" })}>
                  CANCEL
                </Button>,
                <Button key="import" className="upload-app-btn--primary" onClick={importFile} loading={loadingButton}>
                  Upload
                </Button>
              ]
              : null
          }
        >
          <div className="app-import-header">
            <AppCategories
              data-test-id="categories"
              onClick={onClick}
              activeTab={activeTab}
              allCatagories={allCatagories}
              setSearchVal={setSearchValue}
            />
          </div>
          {!appData.length ? <Spinner/> :
            activeTab === "Upload Apps" ?
              <UploadApps
                appId={appIdt}
                appNa={appNa}
                selectedAppVal={selectedAppVal}
                setErrorMessage={errorMessage}
                onAppDataChange={handleAppDataChange}
                visible={visible}
              />
              :
              <ImportInstalledApp
                activeTab={activeTab}
                apps={getFilteredApps()}
                setVisible={setVisible}
                setSelectedApp={setSelectedApp}
                searchValue={searchValue}
              />
          }
        </Modal>
        :
        <Modal
          className="override-modal"
          title={`IMPORT ${selectedApp.name}`}
          visible={visible.visible}
          onCancel={() => {
            setVisible({ visible: false, type: "Import" });
          }}
          footer={[
            <div className="importapp-footer" key="">
              <Button type="default" className="cancel" onClick={() => { setVisible({ visible: false, type: "Import" }) }}>
                Cancel
              </Button>
              <Button type={"primary"} className="submit" onClick={handleImport} loading={loading}>
                Import
              </Button>
            </div>
          ]}
        >
          {selectedApp && (
            <Form className={"override-content"}>
              <Form.Item
                label={<span className="labelName">Display Name</span>}
              >
                <Input
                  value={appName}
                  onChange={(e) => {
                    const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;
                    if (e.target.value === '' || re.test(e.target.value)) {
                      let val = e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "")
                      let value = val.replace(/ /g, "_")
                      setAppName(e.target.value)
                      setAppIdentifier(value)
                    }
                  }
                  }
                />
              </Form.Item>
              <Form.Item
                label={<span className="labelName">Name(identifier)</span>}
              >
                <Input
                  data-test-id="function_name"
                  value={appIdentifier}
                  onChange={(e) => {
                    const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
                    if (e.target.value === '' || re.test(e.target.value)) {
                      setAppIdentifier(e.target.value)
                    }
                  }}
                />
              </Form.Item>
            </Form>)}
        </Modal>
      }
    </div>
  );
};